import React from "react";
import { Col, Row } from "react-bootstrap";
import { ToolbarItem } from "../../Editor/Toolbar/ToolbarItem";
import { ToolbarSection } from "../../Editor/Toolbar/ToolbarSection";
import { Dimensions } from "../Common/Dimensions";
import { Margin } from "../Common";

export const VideoSettings = () => {
  return (
    <>
      <ToolbarSection title="Video source" props={["src", "alt"]}>
        <Row>
          <Col xs={12} sm={12} md={12}>
            <ToolbarItem mediaType="VIDEO" propKey="src" type="upload" label="Upload image" />
            <ToolbarItem propKey="src" type="text" label="Video src" />

            <ToolbarItem propKey="alt" type="text" label="Image alt" />
          </Col>
        </Row>
      </ToolbarSection>
      <Dimensions />
      <ToolbarSection title="Decorations" props={["borderRadius", "shadow"]}>
        <ToolbarItem propKey="borderRadius" type="text" label="Radius" />
      </ToolbarSection>
      <Margin />
    </>
  );
};
